export class ViewPort {
  /** Display dimensions in CSS pixels (what the user sees). */
  public displayWidth: number;
  public displayHeight: number;

  constructor(
    /** Render width in GPU pixels. */
    public width: number,
    /** Render height in GPU pixels. */
    public height: number,
  ) {
    this.displayWidth = width;
    this.displayHeight = height;
  }

  public get aspectRatio(): number {
    return this.width / this.height;
  }

  public toString(): string {
    return `${this.width} x ${this.height}`;
  }
}
